<template>
  <div
    class="SidebarBurger"
    @click.self="showBurger(false)"
    @keypress.enter.self="showBurger(false)">
    <MainLogo
      format="png"
      type="white" />

    <div class="menu-toggle">
      <Icon
        :name="isToggled ? 'cross' : 'menu'"
        @click="showBurger(!isToggled)" />
    </div>

    <transition name="slide-down">
      <div
        v-if="isToggled"
        class="menu-content"
        @click.self="showBurger(false)"
        @keypress.enter.self="showBurger(false)">
        <nav>
          <template v-for="(link, index) in links">
            <MenuLink
              :key="index"
              :index="index"
              :link="link"
              @click="$emit('update:activeIndex', index);link.children ? null : showBurger(false)" />
            <transition-group :key="`${index}_transition`" appear name="slide-down">
              <div
                v-if="activeIndex === index && link.children && link.children.length"
                :key="`${index}_children`"
                class="children">
                <MenuLink
                  v-for="(child, childIndex) in link.children"
                  :key="`${index}_${childIndex}`"
                  :index="childIndex"
                  :link="child"
                  @click="$emit('update:activeIndex', index);showBurger(false)" />
              </div>
            </transition-group>
          </template>
        </nav>
      </div>
    </transition>
  </div>
</template>

<script>
import MainLogo from './MainLogo'
import MenuLink from './MenuLink'

export default {
  components: {
    MainLogo,
    MenuLink,
  },
  props: {
    links: { type: Array, default: () => ([]) },
    activeIndex: { type: Number, required: false },
  },
  data() {
    return {
      isToggled: false,
    }
  },
  methods: {
    showBurger(value) {
      this.isToggled = value
    },
  },
}
</script>

<style lang="scss">
$_menu-height: $sidebar-burger-height;

.SidebarBurger {
  align-items: center;
  border-bottom: 1px solid $border-color;
  display: flex;
  height: $_menu-height;
  justify-content: space-between;
  left: 0;
  line-height: 2rem;
  padding: 1rem;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;

  .menu-toggle {
    background-color: $white-bis;
    border: 1px solid $text-color;
    border-radius: $radius-md;
    cursor: pointer;
    font-size: 1.5rem;
    height: 2rem;
    line-height: 1.25;
    opacity: 0.85;
    text-align: center;
    width: 2rem;
  }

  .menu-content {
    height: calc(100% - #{$_menu-height});
    left: 0;
    position: fixed;
    top: $_menu-height;
    width: 100%;

    nav {
      .MenuLink {
        padding: 0.5rem 1rem;
        position: relative;
        width: 100%;

        a {
          &::after {
            @include trans;
            background: transparent;
            bottom: 0;
            content: ' ';
            display: block;
            height: 1px;
            position: absolute;
            right: 0;
            width: 1px;
          }

          &.router-link-active {
            opacity: 1;

            &::after {
              background: $white;
              border-radius: $radius 0 0 $radius;
              height: 100%;
              left: auto;
              top: 0;
              width: 4px;
            }
          }
        }
      }
    }
  }
}
</style>
